/**
 * R-72 — Load cached distribution baseline JSON (module init).
 */
import type { ReportTypeId } from '../../config/reportTypes';
import { REPORT_TYPE_REGISTRY } from '../../config/reportTypes';
import type { DistributionBaseline, DistributionBaselineFile } from './distributionBaselineBuilder';
import { buildPlaceholderBaseline } from './distributionBaselineBuilder';
import baselineJson from './data/distributionBaseline.json';

let cached: DistributionBaselineFile | null = null;

function loadFile(): DistributionBaselineFile {
  if (cached) return cached;
  cached = baselineJson as DistributionBaselineFile;
  return cached;
}

export function getDistributionBaselineFile(): DistributionBaselineFile {
  return loadFile();
}

export function getBaselineForReportType(reportTypeId: ReportTypeId): DistributionBaseline {
  const file = loadFile();
  const baseline = file.baselines?.[reportTypeId];
  if (baseline) return baseline;

  const placeholder = buildPlaceholderBaseline(10);
  return placeholder;
}

export function getAllBaselines(): Partial<Record<ReportTypeId, DistributionBaseline>> {
  const file = loadFile();
  const out: Partial<Record<ReportTypeId, DistributionBaseline>> = { ...file.baselines };
  for (const id of Object.keys(REPORT_TYPE_REGISTRY) as ReportTypeId[]) {
    if (!out[id]) out[id] = buildPlaceholderBaseline(10);
  }
  return out;
}

/** Test hook — reset module cache. */
export function resetDistributionBaselineCache(): void {
  cached = null;
}
